module.exports = __webpack_public_path__ + "img/logo_text.107ff18e.png";